import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { UPDATE_USER_SETTINGS_MUTATION } from '../graphql/mutations'
import { transformToSaveUserSettingsArgs } from '../graphql/transformers'
import { UPDATE_USER_SETTINGS } from '../redux/action-types'

const useUpdateUserSettingsMutation = () => {
  const dispatch = useDispatch()

  const { isLoading, error } = useSelector(
    store => store.account.updateUserSettings,
  )

  const mutate = useCallback(
    data =>
      apolloService.mutate(
        UPDATE_USER_SETTINGS_MUTATION,
        transformToSaveUserSettingsArgs(data),
        dispatch,
        UPDATE_USER_SETTINGS,
      ),
    [dispatch],
  )

  return [mutate, { isLoading, error }]
}

export default useUpdateUserSettingsMutation
